// extracted by mini-css-extract-plugin
export default {"wrap":"BaechaList_wrap__p7q1r","topWrap":"BaechaList_topWrap__JXjZA"};